<template>
  <div >
    <headertop></headertop>
    <div class="main">
      <h1>试卷列表</h1>
          <div class="con">
            <!-- 搜索框 -->
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model.trim="evaluation.search"
             @keyup.enter.native="searchAllCompany('exam')"  style="width: 90%;margin: 0 5%;">
            </el-input>
            <!-- 表格 -->
            <el-table :data="evaluation.exam.list" stripe style="width: 90%;margin: 0 5%;" fit>
              <el-table-column prop="name" sortable label="试卷名称">
              </el-table-column>
              <el-table-column label="发布人" prop="push">
              </el-table-column>
              <el-table-column prop="c_time" sortable label="发布时间"width="250" >
              </el-table-column>
              <el-table-column prop="e_s_time" sortable label="开始日期">
              </el-table-column>
              <el-table-column prop="e_e_time" sortable label="结束日期">
              </el-table-column>
              <el-table-column label="考试状态" >
                <template slot-scope="scope">
                  <span
                    v-if="new Date(evaluation.exam.list[scope.$index].e_s_time).getTime()>new Date(evaluation.exam.today).getTime()">
                    <el-tooltip class="item" effect="dark" content="考试时间还没到,请耐心等待" placement="top-start">
                          <span>
                            <img src="../../../assets/red.jpg" class="imgs" />
                            未开启
                          </span>
                    </el-tooltip>
                  </span>
                  <span v-else-if="new Date(evaluation.exam.list[scope.$index].e_e_time).getTime()>new Date(evaluation.exam.today).getTime()">
                    <el-tooltip class="item" effect="dark" content="考试进行中,快来参加考试吧" placement="top-start">
                          <span>
                            <img src="../../../assets/green.jpg" class="imgs" />
                            进行中
                          </span>
                    </el-tooltip>
                  </span>
                  <span v-else>
                    <el-tooltip class="item" effect="dark" content="考试时间已结束" placement="top-start">
                    <span>
                      <img src="../../../assets/red.jpg" class="imgs" />
                      已结束
                    </span>
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="考核状态">
                <template slot-scope="scope">
                  <span
                    v-if="new Date(evaluation.exam.list[scope.$index].e_s_time).getTime()>new Date(evaluation.exam.today).getTime()">

                    <el-tooltip class="item" effect="dark" content="考试还未开始" placement="top-start">
                          <span>
                             <img src="../../../assets/red.jpg" class="imgs" />未开启
                          </span>
                    </el-tooltip>
                    </span>
                  <span v-else>
                    <span v-if="evaluation.exam.list[scope.$index].c_e_time==0">
                       <el-tooltip class="item" effect="dark" content="您还未参加考试" placement="top-start">
                             <span>
                                <img src="../../../assets/red.jpg" class="imgs" />未进行
                             </span>
                       </el-tooltip>
                    </span>
                    <span v-else>
                      <span v-if="evaluation.exam.list[scope.$index].status=='1'">
                        <el-tooltip class="item" effect="dark" content="您开始未通过哦,还要继续努力" placement="top-start">
                              <span>
                                 <img src="../../../assets/red.jpg" class="imgs" />未通过
                              </span>
                        </el-tooltip>
                        </span>
                        <span v-if="evaluation.exam.list[scope.$index].status=='2'">
                          <el-tooltip class="item" effect="dark" content="恭喜您通过考试" placement="top-start">
                                <span>
                                   <img src="../../../assets/green.jpg" class="imgs" />通过
                                </span>
                          </el-tooltip>
                          </span>
                      </span>

                      </span>
                    </span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span v-if="new Date(evaluation.exam.list[scope.$index].e_e_time).getTime()<new Date(evaluation.exam.today).getTime()">
                    <span v-if="evaluation.exam.list[scope.$index].overdue!='0'">
                      <span v-if="evaluation.exam.list[scope.$index].exam_status">
                        <el-button size="mini" @click="study_train(evaluation.exam.list[scope.$index].num,'train')"  v-loading.fullscreen.lock="evaluation.fullscreenLoading">进行补考</el-button>
                      </span>
                      <span v-else>
                        <el-button size="mini" @click="study_exam(exam.list[scope.$index].num)"  v-loading.fullscreen.lock="evaluation.fullscreenLoading">试卷查看</el-button>
                      </span>
                    </span>
                    <span v-else style="color: red;">
                      <!-- <el-tooltip class="item" effect="dark" content="考试通道已关闭,不可逾期考试哦" placement="top-start">
                            <span>
                               考试已结束
                            </span>
                      </el-tooltip> -->
                      <el-button size="mini" @click="study_exam(evaluation.exam.list[scope.$index].num)"  v-loading.fullscreen.lock="evaluation.fullscreenLoading">试卷查看</el-button>
                    </span>
                  </span>
                  <span v-else-if="new Date(evaluation.exam.list[scope.$index].e_s_time).getTime()>new Date(evaluation.exam.today).getTime()">
                    考试未开始
                  </span>
                  <span v-else>
                    <span v-if="evaluation.exam.list[scope.$index].c_e_time!='0'">
                      <span v-if="evaluation.exam.list[scope.$index].exam_status">
                        <el-button size="mini" @click="study_train(evaluation.exam.list[scope.$index].num,'train')"  v-loading.fullscreen.lock="evaluation.fullscreenLoading">进行补考</el-button>
                      </span>
                      <span v-else>
                        <el-button size="mini" @click="study_exam(evaluation.exam.list[scope.$index].num)"  v-loading.fullscreen.lock="evaluation.fullscreenLoading">试卷查看</el-button>
                      </span>
                    </span>
                    <span v-else>
                      <el-button size="mini" @click="study_train(evaluation.exam.list[scope.$index].num,'train')">进行考试</el-button>
                    </span>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 分页-->
          <div class="block center">
            <el-pagination @size-change="(val) => handleSizeChange('exam', val)"
              @current-change="(val) => handleCurrentChange('exam', val)" :current-page="evaluation.exam.currentPage"
              :page-sizes="[10, 20, 30, 40]" :page-size="exam.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="evaluation.exam.total">
            </el-pagination>
          </div>
      <!--试卷查看-->
      <el-dialog title="试卷查看" :visible.sync="evaluation.exam.exam_show">
        <el-table
            :data="evaluation.exam.details_list"
            stripe
            style="width: 100%">
            <el-table-column prop="c_time" label="考试时间">
            </el-table-column>
            <el-table-column label="分数" prop="score">
            </el-table-column>
            <el-table-column
                  fixed="right"
                  label="操作"
                  >
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="exam_see(scope.row.num)">查看</el-button>
                  </template>
                </el-table-column>
          </el-table>
      </el-dialog>

      <!--温馨提示-->
      <el-dialog  :visible.sync="evaluation.type_show" width='30%'>
        <span >
          <span style="color: red;font-size: 1.25rem;"> 您想了解：</span></br></br>
          对法规与指南的了解程度吗？</br></br>
          招聘过程中，待入职员工的真实专业水平吗？</br></br>
          本部门员工的专业水平吗？</br></br>
          员工专业水平的不足之处吗？</br></br>
          方便、简单、易操作给员工进行自由组卷测试吗？</br></br>
          自己的专业水平吗？</br></br>
          <span style="color: blue;font-size: 1.25rem;">测评模块</span>满足您的各种测试需求</br></br>
          <span style="color: red;"> 如有需要请联系王老师(13260265598 同微信)</span></br></br>
        </span>

      </el-dialog>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script>
    import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  import html2canvas from 'html2canvas';
  export default {
    data() {
      return {
        evaluation:{
          type_show:false,
          dstimers:null,
          autograph:{
            time:'',
            show:false,
            input:'',
            num:''
          },
          fullscreenLoading:false,
          search: '',
          exam: {
            list: [],
            currentPage: 1, // 当前页码
            total: 0, // 总条数
            pageSize:10,
            today: '',
            exam_show:false,//考试弹框
            details_list:[],
          },
        }

      }
    },
    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted() {
      this.get_task_eval()
      this.now_day_eval()

    },
    methods: {
      now_day_eval(){
        var nowDate = new Date();
        var date = {
          year: nowDate.getFullYear(),
          month: nowDate.getMonth() + 1,
          day: nowDate.getDate(),
        }
        var dayDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day)
        this.evaluation.exam.today=dayDate
      },
      get_task_eval(){
        let _this=this
        _this.axios.get('/v2/user_evaluate/exam_list', {
          params: {
            page: _this.evaluation.exam.currentPage,
            limit:Number(_this.evaluation.exam.pageSize),
            'keyword':_this.evaluation.search,
          }
        }).then(function(res) {
          if (res.status == '200') {
            if (res.data.code == '1') {
             _this.evaluation.evaluation.exam.list=res.data.data.list
             _this.evaluation.exam.currentPage=res.data.data.currentPage
             _this.evaluation.exam.total=res.data.data.total
             _this.evaluation.exam.pageSize=Number(res.data.data.pageSize)
            } else {
              _this.evaluation.type_show=true
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      //考试详情
      exam_see_eval(num){
        window.open('evalsubjeCtresult?num='+num,'_blank');
      },
      //搜索框回车事件
       searchAllCompany_eval(type){
         let _this=this;
           _this.get_task_eval()
         // _this.search=''
       },
      /* 分页*/
      handleSizeChange_eval(type, val) {
        let _this = this
        _this.evaluation.exam.pageSize = val
        _this.evaluation.exam.currentPage = 1
          _this.get_task_eval()
      },
      handleCurrentChange_eval(type, val) {
        let _this = this
        _this.evaluation.exam.currentPage = val
          _this.get_task()
      },
      study_exam_eval(val){
        let _this=this
        _this.axios.get('/v2/user_evaluate/get_exam_list',{params:{'num':val}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.evaluation.exam.details_list=res.data.data
              _this.evaluation.exam.exam_show=true
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      /* study*/
      study_train_eval(val,type){
        let _this=this
        _this.axios.get('/v2/user_evaluate/get_subject',{
          params: {num: val },}
        ).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              window.open('evalsubject?num='+val,'_blank');
             }else{
               _this.$message.error(res.data.msg);
             }
          }
         })

      }

    }
  }
</script>

<style scoped>
  table
  {
  border-collapse :collapse ;
  width: 100%;
  }
  th,td
  {
  width:23%;
  height:40px;
  font-size:15px;
  }
 >>>.el-dialog__body{
    padding: 0 2rem 2rem 2rem;
  }
  .imgs{
    width: 10%;
    height: 10%;
  }
  .cert_bk {
    width: 100%;
    height: 30rem;
    background-image: url(../../../assets/cert_bk.jpg);
    background-size: 100% 100%;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  h1 {
    margin: 20px;
  }

.el-tabs {
    width: 90%;
    margin: 0 5%;
  }

.el-form-item__label {
    padding-right: 30px;
  }

  .el-form-item .el-avatar {
    width: 100px;
    height: 100px;
  }

  .el-button {

    margin: 2px 0;
  }

  .con {
    /* 分页占位*/
    min-height: calc(100vh - 504px);
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }

  .certimg {
    width: 100%;
  }

  /* 证书 */
  .restore-btn{
    position: absolute;
    bottom: 0.2rem;
    right: 10px;
  }
  /**路由 */
  .linkz{
    text-decoration:none;
  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/evaluation/list.vue